/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import {
  NGX_MAT_DATE_FORMATS,
  NgxMatDateAdapter,
} from '@angular-material-components/datetime-picker';
import { NgModule } from '@angular/core';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import {
  NGX_MAT_LUXON_DATE_ADAPTER_OPTIONS,
  NgxMatLuxonAdapter,
} from './luxon-adapter';
import { NGX_MAT_LUXON_FORMATS } from './luxon-formats';

@NgModule({
  providers: [
    {
      provide: NgxMatDateAdapter,
      useClass: NgxMatLuxonAdapter,
      deps: [MAT_DATE_LOCALE, NGX_MAT_LUXON_DATE_ADAPTER_OPTIONS],
    },
  ],
})
export class NgxLuxonDateModule {}

@NgModule({
  imports: [NgxLuxonDateModule],
  providers: [
    { provide: NGX_MAT_DATE_FORMATS, useValue: NGX_MAT_LUXON_FORMATS },
  ],
})
export class NgxMatLuxonModule {}
